import RegulatoryChat from './RegulatoryChat'

export default RegulatoryChat
